import React from 'react';

import { Grid } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

import GeneralAccordeon from './GeneralAccordeon';
import BasicAccordeon from './BasicAccordeon';
import AdditionalAccordeon from './AdditionalAccordeon';
import { AccordionNameEnum } from 'utils/drupalEntities';

const CustomForm = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

const DrawerContent = ({
  generalData,
  basicData,
  additionalData,
  setCustomErrors,
  getValues,
  setValue,
  control,
  watch,
  fields,
  append,
  remove,
  langCode = 'it',
  isBrand,
  brand,
  productLangCode,
  openAccordions = [],
  setInfoDialog,
  isExhibitorGold = false,
}) => {
  return (
    <Grid
      style={{
        maxWidth: '680px',
        height: '100%',
        flexDirection: 'column',
      }}
      container
    >
      <CustomForm>
        <Grid style={{ flex: 0 }} item xs={12}></Grid>
        <GeneralAccordeon
          control={control}
          setValue={setValue}
          watch={watch}
          setCustomErrors={setCustomErrors}
          generalData={generalData}
          langCode={langCode}
          isBrand={isBrand}
          productLangCode={productLangCode}
          setInfoDialog={setInfoDialog}
          isOpen={
            !!openAccordions.find((ac) => ac === AccordionNameEnum.GENERAL)
          }
        />
        <Grid style={{ flex: 0 }} item xs={12}>
          <BasicAccordeon
            control={control}
            setValue={setValue}
            watch={watch}
            setCustomErrors={setCustomErrors}
            basicData={basicData}
            getValues={getValues}
            isBrand={isBrand}
            brand={brand}
            productLangCode={productLangCode}
          />
        </Grid>
        <Grid style={{ display: 'flex', flex: 1 }} item xs={12}>
          <AdditionalAccordeon
            control={control}
            setValue={setValue}
            watch={watch}
            setCustomErrors={setCustomErrors}
            additionalData={additionalData}
            getValues={getValues}
            fields={fields}
            append={append}
            remove={remove}
            langCode={langCode}
            isBrand={isBrand}
            setInfoDialog={setInfoDialog}
            productLangCode={productLangCode}
            isExhibitorGold={isExhibitorGold}
          />
        </Grid>
      </CustomForm>
    </Grid>
  );
};

export default DrawerContent;
